import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserStore } from '../stores/userStore';

interface WorkerRouteProps {
  children: React.ReactNode;
}

/**
 * WorkerRoute — blocks confirmed employers from worker-only social screens.
 * Employers (is_employer === true) are redirected to /employer-dashboard.
 * Must be nested inside AuthenticatedRoute.
 */
const WorkerRoute: React.FC<WorkerRouteProps> = ({ children }) => {
  const { user } = useUserStore();

  if (user?.is_employer) {
    return <Navigate to="/employer-dashboard" replace />;
  }

  return <>{children}</>;
};

export default WorkerRoute;
